import { Component, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ModalClosedReason, ModalContent } from '@ap/modal';

import { MijnTokensBrowserNavigation } from '../mijn-tokens-browser.navigation';

import content from './logout-modal.content.json';

/**
 * @module LogoutModalModule
 * @ngdoc component
 * @name LogoutModalComponent
 */
@Component({
    selector: 'logout-modal',
    templateUrl: 'logout-modal.component.html',
    standalone: false
})
export class LogoutModalComponent extends ModalContent<any> implements OnInit {
    private redirectUrl: string;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly navigation: MijnTokensBrowserNavigation
    ) {
        super();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.redirectUrl = this.contentService.get('mijn-tokens-browser.logout-modal.url');
    }

    public onRegisterBrowser(): void {
        this.close(ModalClosedReason.ACCEPTED);
    }

    public onCancel(): void {
        this.navigation.external(this.redirectUrl);
    }
}
